import { useState } from 'react';   
import NavMenuView from './NavMenuView';
import NavMenuEdit from './NavMenuEdit';

import {ReactComponent as SettingsIcon} from '../../../images/icons/General/settings-01.svg';
import { navService, confService } from '../../../Services';

const NavMenu = ({ items, permissions, modules, exhibitDiver, canEdit, onSave, setOpenNav }) => {
    const [editMode, setEditMode] = useState(false);
    const [availablePages, setAvailablePages] = useState([]);
    const [loading, setLoading] = useState(false);

    const enterEditMode = async () => {
        setLoading(true);
        
        const res = await confService.getPages();
        
        setAvailablePages(res.list || []);

        setLoading(false);
        setEditMode(true);
    };

    const handleSave = async (updatedItems) => {
        await onSave(updatedItems);
        setEditMode(false);
        setAvailablePages([]);
    };

    const handleCancel = () => {
        setEditMode(false);
        setAvailablePages([]);
        setLoading(false);
    };

    if (editMode) {
        return (
            <NavMenuEdit
                initialItems={items}
                availablePages={availablePages}
                onSave={handleSave}
                onCancel={handleCancel}
            />
        );
    }

    return (
        <>
            <NavMenuView
                items={items}
                permissions={permissions}
                modules={modules}
                exhibitDiver={exhibitDiver}
                setOpenNav={setOpenNav}
            />
            {canEdit && (
                <button
                    type="button"
                    className="nav-edit-toggle"
                    onClick={enterEditMode}
                    disabled={loading}
                >
                    {loading ? 'Loading…' : <><SettingsIcon style={{width: '20px'}} /> Edit menu</>}
                </button>
            )}
        </>
    );
};

export default NavMenu;
